import styled from 'styled-components/macro'

import { Card, Text } from '@loadsmart/loadsmart-ui'
import { getToken, type ThemeToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const Subtitle = styled(Text).attrs({ variant: 'chips-sm', color: 'color-neutral' })``

export const Info = styled(Text).attrs({ variant: 'body-bold' })`
  text-transform: capitalize;
`

export const InfoWrapper = styled(Card.Body)`
  display: flex;
  flex-wrap: wrap;
  gap: ${getToken('space-m')};
`

export const SingleInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: ${getToken('space-xl')};
`

export const DeadlineWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const DeadlineIndicator = styled.div<{ $colorToken: ThemeToken }>`
  min-width: ${getToken('space-s')};
  min-height: ${getToken('space-s')};
  border-radius: ${getToken('border-radius-s')};
  margin-left: ${getToken('space-s')};
  background-color: ${({ $colorToken }) => getToken($colorToken)};
  box-shadow: 0px 0px 4px ${({ $colorToken }) => getToken($colorToken)};
`

export const ShipperInfoWrapper = styled.div`
  padding: 0 0 ${getToken('space-m')} ${getToken('space-m')};
`
